<template>
  <div class="about">
    <head-menu current="3"/>
      <div class="connet">
        <div class="text" v-html="con"></div>
        <div class="code">
            <p>相关合作联系邮箱：opensource@baidu.com </p>
            <p>扫码关注：百度开源社区</p>
            <img src="../../../images/qrcode.png">
        </div>
      </div>
    <footer-links :footlinks="footlinks"/>
  </div>
</template>
<script>
import HeadMenu from "../../../common/head-menu";
import FooterLinks from "../../../common/footer-links";
export default {
  components: {
    HeadMenu,
    FooterLinks
  },

  data() {
    return {
      con: `
                <p>百度开源介绍</p>
                <span class="tip">1、百度对开源的理解</span>
                <br/>
                开源从最基本来说，是开放源码基础上的一种合作开发模式，为了保证这种模式能持久下去，衍生了各种License和各种商业模式，才有各种横向的开源组织，包括基金会等；
                <br/>
                <span class="tip">2、百度对开源的认识</span>
                <br/>
                现阶段企业开发者越来越成为主流，Coopetition（竞争和合作交织），AI领域内开源成为建技术生态的默认选择
                <br/>
                <span class="tip">3、百度开源战略</span>
                <br/>
                内部开源协同合作，对外开源建设生态。
                <br/>
                <span class="tip">4、百度开源历程</span>
                <br/>
                2019年11月22日 百度安全开源项目MesaTEE正式进入Apache孵化器<br/>

                2019年11月15日 百度统一七层流量转发平台BFE正式开源<br/>

                2019年5月30日 百度自研底层区块链技术 XuperChain 正式开源<br/>

                2018年12月20日   百度智能小程序正式开源<br/>

                2018年11月 brpc进入Apache孵化器<br/>

                2018年7月   Doris 在GitHub1年后，获得Apache基金会的认可，通过投票成功进入Apache孵化器<br/>

                2017年7月 百度AI开发者大会上公布Apollo开源1.0<br/>

                2017年4月 百度宣布阿波罗计划，无人车系统开放含开源<br/>

                2016年9月 深度学习开源平台PaddlePaddle在开源社区Github及百度大脑平台开源<br/>

                2013年4月 FE的可视化产品Echarts率先在github开源,并在2018 年3月,全票通过进入 Apache 孵化器<br/>


            `
    };
  }
};
</script>
<style lang="less">
.about {
  .connet {
    max-width: 1000px;
    margin: 20px auto;
    border: 3px solid #eee;
    border-radius: 5px;
    box-shadow: 5px 5px 5px #eee;
    padding: 30px;
    line-height: 56px;
    font-size: 15px;
    color: #333;
    .text{
      p{
        font-size: 20px;
        text-align: center;
        font-weight: bold;
      }
      .tip{
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
    }
  }

  .linksHead {
    display: none;
  }

  .code{
    width: 400px;
    margin: 0 auto;
    text-align: center;
    p{
      margin: 20px;
    }
  }

  .footer ul {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/activity/about/index.vue